import React from 'react';
import { Container } from '@mui/system';

export default function Layout({ children }) {
  return <Container className='container-75' maxWidth='xl'>{children}</Container>;
}
